<template>
  <i
    v-if="loyaltyTier && isLoyaltyBadge(badge)"
    class="star loyalty-star-image"
  />
</template>

<script setup>
import { computed } from 'vue';
import loyaltyBadgeIcons from '../../../utils/loyaltyStarImagePaths';

const props = defineProps({
  loyaltyBadge: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  badge: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});

const loyaltyBadgeRegex = /(star money|star rewards points)/i;

const loyaltyTier = computed(() => props.loyaltyBadge?.tierInfo?.tierName?.toLowerCase());

const starImagePath = computed(() => loyaltyBadgeIcons[loyaltyTier.value]);

const isLoyaltyBadge = (badge) => loyaltyBadgeRegex.test(badge?.header?.toLowerCase());

</script>

<style brand="mcom" scoped>
.star{
    background-repeat: no-repeat;
    display: inline-block;
    height: 20px;
    width: 20px;
    background-size: 18.37px 17.5px;
    align-self: flex-start;
    margin-right: 4px;
}

.loyalty-star-image{
  background-image: v-bind(starImagePath);
}
</style>
